import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from "../config/api";
import { useNavigate } from "react-router-dom";

interface Store {
  id: number;
  name: string;
  apiEndpoint: string;
}

export default function StoresList() {
  const { t } = useTranslation();
  const [stores, setStores] = useState<Store[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE_URL}/stores`)
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch stores");
        return res.json();
      })
      .then(setStores)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">{t('admin:allStores', 'All Stores')}</h1>
      {loading && <div>{t('admin:loading', 'Loading...')}</div>}
      {error && <div className="text-red-600">{error}</div>}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {stores.map(store => (
          <button
            key={store.id}
            className="bg-white shadow-lg rounded-xl p-6 border border-slate-200 flex flex-col items-center cursor-pointer hover:shadow-2xl transition"
            onClick={() => navigate(`/admin/stores/${store.id}`)}
          >
            <div className="text-lg font-semibold text-teal-700 mb-2">{store.name}</div>
            <div className="text-slate-500 text-sm break-all">{store.apiEndpoint}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
